const Admin = () => import(/* webpackChunkName: "proj" */ './Admin');
const Appl = () => import(/* webpackChunkName: "proj" */ './Appl');

export default {
  routes: [
    {
      path: '/proc/inco2019/admin',
      name: 'proc_inco2019_admin',
      component: Admin,
      meta:{public:true}
    },
    {
      path: '/proc/inco2019/appl',
      name: 'proc_inco2019_appl',
      component: Appl,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/proc/inco2019/router.js